import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';
import { UrlNames } from 'modules/app/constants';
import { configService } from 'modules/app/services';

import type { LeaveReason, NatterId } from './types';

const getBaseURL = () => configService.getUrl(UrlNames.OpenNatterApi);

export const openNatterApi = createApi({
  reducerPath: 'openNatterApi',
  tagTypes: ['NATTERS_LIST', 'NATTER_DETAILS'],
  baseQuery: axiosBaseQuery({ baseURL: getBaseURL }),
  endpoints: (builder) => ({
    postReady: builder.mutation<void, NatterId>({
      query: (id) => ({
        url: `/open-natters/${id}/ready`,
        method: 'POST',
      }),
    }),
    postLeave: builder.mutation<{ id: NatterId }, { id: NatterId; reason?: LeaveReason }>({
      query: ({ id, reason }) => ({
        url: `/open-natters/${id}/leave`,
        method: 'POST',
        data: reason ? { reason } : undefined,
      }),
      transformResponse: (_, __, { id }) => ({ id }),
    }),
    postRating: builder.mutation<void, { id: NatterId; rating: number }>({
      query: ({ id, rating }) => ({
        url: `/open-natters/${id}/rating`,
        method: 'POST',
        data: { rating },
      }),
    }),
    postAnswers: builder.mutation<void, { id: NatterId; answers: string[] }>({
      query: ({ id, answers }) => ({
        url: `/open-natters/${id}/answers`,
        method: 'POST',
        data: { answers },
      }),
    }),
  }),
});

export const { usePostRatingMutation } = openNatterApi;
